export type SnActionClickHandler<D> = (data?: D) => void;
